import Crud from '../components/Domains/Crud.vue'
import Add from '../components/Domains/Add.vue'

let routes = {
    path: '/domains',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
      {
        path: '/domains',
        name: 'Domínios',
        component: Crud
      },
      {
        path: '/domains/add',
        name: 'Novo Domínio',
        component: Add
      },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/domains.js